var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-center__main-page-header"},[_c('div',{staticClass:"header__title"},[_vm._t("title")],2),_c('div',{staticClass:"header__hint"},[_vm._t("hint")],2),_c('div',{staticClass:"header__bt"},[_vm._t("bt")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }